import React, { useCallback, useEffect, useRef, useState } from "react";
import { ReelCard } from "../reel-card";
import "./ReelList.css";

// export const ReelList = ({ properties, onEndReached, loading }) => {
// export const ReelList = ({
//   properties,
//   onEndReached,
//   loading,
//   onAddFavorite,
// }) => {
export const ReelList = ({
  userId,
  isMyReelsView,
  properties,
  onEndReached,
  loading,
  onAddFavorite,
}) => {
  const containerRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const observer = useRef();

  const handleScroll = () => {
    const container = containerRef.current;
    const children = container.children;
    const scrollTop = container.scrollTop;
    const height = container.clientHeight;

    for (let i = 0; i < children.length; i++) {
      const childTop = children[i].offsetTop;
      const childBottom = childTop + height;

      if (
        scrollTop >= childTop - height / 2 &&
        scrollTop < childBottom - height / 2
      ) {
        break;
      }
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    let timeout;
    const delayedScroll = () => {
      clearTimeout(timeout);
      timeout = setTimeout(handleScroll, 100);
    };
    container.addEventListener("scroll", delayedScroll);
    return () => {
      container.removeEventListener("scroll", delayedScroll);
    };
  }, []);

  const lastReelRef = useCallback(
    (node) => {
      if (!node || !onEndReached) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          onEndReached();
        }
      });

      observer.current.observe(node);
    },
    [onEndReached]
  );

  return (
    <div className="reel-scroll-container" ref={containerRef}>
      {properties.length === 0 && !loading ? (
        <div
          className="alert alert-warning"
          style={{ textAlign: "center", padding: "1rem" }}
        >
          <h5>
            <i className="fa fa-warning" /> No Reel Available.
          </h5>
        </div>
      ) : (
        properties.map((p, i) => (
          <div
            key={i}
            className="reel-item"
            ref={i === properties.length - 1 ? lastReelRef : null}
          >
            <ReelCard
              userId={userId}
              key={p?.ItemId}
              property={p}
              isMuted={isMuted}
              setIsMuted={setIsMuted}
              onAddFavorite={onAddFavorite}
            />
          </div>
        ))
      )}

      {loading && (
        <div
          className="loading-spinner"
          style={{ textAlign: "center", padding: "1rem" }}
        >
          <i className="fa fa-spinner fa-spin fa-2x" />
        </div>
      )}
    </div>
  );
};
